<div class='container'>
  <h1>Job Signoff</h1>
  <br />
  <br />
  <button class='btn btn-secondary' routerLink='/job-signoff/land'>Transport Sign off</button>
  <!-- <button class='btn btn-secondary' routerLink='/job-signoff/artic'>Artic Sign off</button> -->
  @if (!this.isYND()) {
    <button class='btn btn-secondary' routerLink='/job-signoff'>Skip Sign off</button>
  }
  @if (!this.isYND()) {
    <button class='btn btn-secondary' routerLink='/job-signoff/shredder'>Shredding Sign off</button>
  }
  <button class='btn btn-secondary' routerLink='/tip-ticket'>Tip Ticket Sign off</button>
  @if (!this.isYND()) {
    <button class='btn btn-secondary' routerLink='/yard-trade-signoff'>Yard Trade Sign off</button>
  }
  <button class='btn btn-secondary' routerLink='/job-signoff/material-uplift'>Material Uplift Sign off</button>
</div>